import { Flex, Space } from "antd";
import { t } from "i18next";
import {
  AppForm,
  RegistrationInput,
  AppButton,
  FillTheFieldErrorMessage,
} from "@/shared/Components";
import type { PhoneNumberProps } from "@/entities/phone-number-form/model";
import styles from "./styles.module.scss";

export const Desktop = ({
  formApi,
  handleSubmit,
  handleCancel,
  submitDisabled,
  isLoading,
}: PhoneNumberProps) => {
  return (
    <AppForm className={styles.form} formApi={formApi} onSubmit={handleSubmit}>
      <Flex gap={8} vertical>
        <FillTheFieldErrorMessage name={"root.mobilePhoneError"} />
        <Flex gap={32} vertical>
          <RegistrationInput
            placeholder={t("registrationPage.userInfoStep.phoneNumber")}
            name="mobilePhone"
          />
          <Space>
            <AppButton
              type="link"
              className={styles.cancel}
              onClick={handleCancel}
              loading={isLoading}
            >
              {t("common.cancel")}
            </AppButton>
            <AppButton
              htmlType="submit"
              type="primary"
              className={styles.submit}
              disabled={submitDisabled}
              loading={isLoading}
            >
              {t("passwordRecoveryPage.sendCode")}
            </AppButton>
          </Space>
        </Flex>
      </Flex>
    </AppForm>
  );
};
